import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {updateLineItem} from "../../../store/actions";

const QuantityInput = ({lineItem}) => {
    const dispatch = useDispatch();
    const {loading} = useSelector(state => state.common);
    const [inputValue, setInputValue] = useState(lineItem?.quantity?.toString() || "0");


    // Sync inputValue when lineItem.quantity changes from external updates
    useEffect(() => {
        if (!loading && lineItem?.quantity !== undefined) {
            setInputValue(lineItem.quantity.toString());
        }
    }, [lineItem?.quantity, loading]);

    const incrementQuantity = async () => {
        if (loading) return;


        const newQuantity = (lineItem?.quantity || 0) + 1;
        try {
            await dispatch(updateLineItem({id: lineItem.id, quantity: newQuantity}));
            setInputValue(newQuantity.toString());

        } catch (error) {
            console.error('❌ INCREMENT: Failed:', error);
        }
    };

    const decrementQuantity = async () => {
        if (loading) return;


        const currentQuantity = lineItem?.quantity || 0;
        const newQuantity = Math.max(0, currentQuantity - 1);
        try {
            await dispatch(updateLineItem({id: lineItem.id, quantity: newQuantity}));
            setInputValue(newQuantity.toString());
        } catch (error) {
            console.error('Failed to update quantity:', error);
        }

    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        setInputValue(value);
    };

    const handleInputBlur = async () => {
        if (loading) return;

        const quantity = parseInt(inputValue);
        if (!isNaN(quantity) && quantity >= 0) {
            // Only update if the value actually changed
            if (quantity !== lineItem?.quantity) {

                try {
                    await dispatch(updateLineItem({id: lineItem.id, quantity: quantity}));
                } catch (error) {
                    console.error('Failed to update quantity:', error);
                    // Reset to current quantity if update failed
                    setInputValue((lineItem?.quantity || 0).toString());
                }
            }
        } else {
            // Reset to current quantity if invalid input
            setInputValue((lineItem?.quantity || 0).toString());
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleInputBlur();
            event.target.blur();
        }
    };

    return (
        <div className="quantity">


            <div
                onClick={decrementQuantity}
                className={`quantity__minus ${loading ? 'quantity__minus--disabled' : ''}`}

            >
                -
            </div>
            <div className="quantity__input-container">
                <input
                    type="number"
                    className={`quantity__input ${loading ? 'quantity__input--updating' : ''}`}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    onKeyPress={handleKeyPress}
                    min="0"
                    disabled={loading}
                    style={{
                        opacity: loading ? 0.7 : 1,
                        cursor: loading ? 'not-allowed' : 'text'
                    }}
                />


            </div>
            <div
                onClick={incrementQuantity}
                className={`quantity__plus ${loading ? 'quantity__plus--disabled' : ''}`}

            >
                +
            </div>
        </div>
    );
};

QuantityInput.propTypes = {
    lineItem: PropTypes.object.isRequired,
};

export default QuantityInput;
